import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-manuel-utilisation',
  imports: [CommonModule, MatIconModule],
  templateUrl: './manuel-utilisation.component.html',
  styleUrl: './manuel-utilisation.component.scss',
})
export class ManuelUtilisationComponent {
  activeSection: string = 'apropos';

  sections = [
    { id: 'apropos', label: 'À propos', icon: 'info' },
    { id: 'connexion', label: 'Connexion', icon: 'login' },
    { id: 'accueil', label: 'Accueil', icon: 'support_agent' },
    { id: 'hebergement', label: 'Hébergement', icon: 'hotel' },
    { id: 'reservation', label: 'Réservation', icon: 'event_available' },
    { id: 'vue-caisse', label: 'Vue Caisse', icon: 'point_of_sale' },
    { id: 'restaurant', label: 'Restaurant', icon: 'restaurant' },
    { id: 'boutique', label: 'Boutique', icon: 'storefront' },
    { id: 'stock', label: 'Gestion des stocks', icon: 'inventory_2' },
    { id: 'location-espace', label: 'Location espace', icon: 'meeting_room' },
    { id: 'tresorerie', label: 'Trésorerie', icon: 'account_balance' },
    { id: 'relation-client', label: 'Relation client', icon: 'handshake' },
    { id: 'fidelite', label: 'Fidélité client', icon: 'star' },
    { id: 'maintenance', label: 'Maintenance', icon: 'build' },
    { id: 'ged', label: 'Documents (GED)', icon: 'folder_open' },
    { id: 'parametres', label: 'Paramètres', icon: 'settings' },
    { id: 'administration', label: 'Administration', icon: 'admin_panel_settings' },
    { id: 'audit', label: 'Audit & Logs', icon: 'manage_search' },
  ];

  scrollTo(id: string) {
    this.activeSection = id;
  }

  hideImg(event: Event) {
    (event.target as HTMLImageElement).style.display = 'none';
  }
}
